(function () {
  var LR_RETURN_PATH = '/pages/lens-replacement';
  var LR_STORAGE_KEY = 'ciw-lr-la-return';

  function isLensReplacementLaFlow() {
    return (
      document.body.classList.contains('template-product-lens-replacement-stub') ||
      !!document.querySelector('.ciw-pdp--lens-replacement')
    );
  }

  function getReturnUrl() {
    var url = new URL(LR_RETURN_PATH, window.location.origin);
    url.hash = 'ciw-frame-selector';
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) {
      url.searchParams.set('preview_theme_id', previewId);
    }
    return url.toString();
  }

  function redirectToLensReplacement() {
    try {
      sessionStorage.removeItem(LR_STORAGE_KEY);
    } catch (e) {}
    window.location.assign(getReturnUrl());
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!document.body.classList.contains('la-modal-open')) return;
      if (!isLensReplacementLaFlow()) return;

      var closeBtn = event.target.closest('.la-prescription-modal-close');
      if (!closeBtn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      redirectToLensReplacement();
    },
    true
  );
})();
